import { gql } from 'react-apollo';

import history from '../../core/history';
import {
  BOOKING_PROCESS_START,
  BOOKING_PROCESS_SUCCESS,
  BOOKING_PROCESS_ERROR,
} from '../../constants';

import { daysCountWithoutWeekends } from '../../helpers/pleXpad';

export function bookingProcess(bookDetails) {

  let {
    listId,
    guests,
    useFreeTrial,
    monthlyPass,
    monthPass,
    startDate,
    endDate,
    preApprove,
    taxRate = 0,
    projectTicketmaster = false,
    checkoutReturn = false,
    reservationId = null,
    paymentIntentId = null,
    currency = null,
    convertedAmount = null,
    monthlyPassAuthDeposit = null,
    monthlyPassSubscriptionStage = null
  } = bookDetails;

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: BOOKING_PROCESS_START,
      payload: {
        bookingLoading: true
      }
    });

    try {

      let query = gql`
          query UserListing($listId:String!) {
            UserListing (listId:$listId) {
              id
              userId
              title
              coverPhoto
              country
              city
              state
              personCapacity
              title
              bookingType
              isHotDesking
              isOpenOnWeekends
              freeTrialDays
              listPhotos{
                id
                name
              }
              user {
                id
                email
                profile{
                  profileId
                  companyName
                  displayName
                  firstName
                  picture
                }
              }
              settingsData {
                id
                settingsId
                listsettings {
                  id
                  itemName
                  settingsType {
                    typeName
                  }
                }
              }
              houseRules {
                houseRulesId
                listsettings{
                  itemName
                  isEnable
                  settingsType {
                    typeName
                  }
                }
              }
              listingData {
                checkInStart,
                checkInEnd,
                basePrice,
                promoPrice,
                cleaningPrice,
                currency,
                weeklyDiscount,
                monthlyDiscount,
                monthPassPrice,
                monthlyPassPrice,
                monthlyPassPromoPrice,
                taxRate
                cancellation {
                  id
                  policyName
                }
              }
              listBlockedPrice {
                id
                listId
                isSpecialPrice
                blockedDates
              }
            }
        }
      `;

      const { data } = await client.query({
        query,
        variables: {
          listId
        },
      });

      bookDetails.listTitle = data.UserListing.title;
      bookDetails.ptm = bookDetails.projectTicketmaster;
      delete bookDetails.projectTicketmaster;

      if( monthlyPass ) {
        let businessDaysToStart = daysCountWithoutWeekends(new Date(), startDate);

        if( bookDetails.monthlyPassSubscriptionStage == undefined ) {
          bookDetails.monthlyPassSubscriptionStage = false;
        }
        bookDetails.monthlyPassAuthDeposit = businessDaysToStart <= 6 && !monthlyPassSubscriptionStage;
      }

      if (data && data.UserListing) {
        dispatch({
          type: BOOKING_PROCESS_SUCCESS,
          payload: {
            data: data.UserListing,
            bookDetails,
            bookingLoading: false
          }
        });

        /* let currentLocation = history.location;
        if( history && !/^\/book\/\d+/i.test(currentLocation.pathname) ) {
          history.push('/book/' + listId + '?bookDetails=' + encodeURIComponent(JSON.stringify(bookDetails)));
        } */

        history.push('/book/' + listId);
      }

    } catch (error) {
      dispatch({
        type: BOOKING_PROCESS_ERROR,
        payload: {
          error,
          bookingLoading: false
        }
      });
      return false;
    }

    return true;
  };
}




// WEBPACK FOOTER //
// src/actions/booking/bookingProcess.js